module.exports = "/images/usa-flag.png?555214a120e23c2c2a18c073c02e20be";